import React from 'react';
import AddTime from './AddTime';
import { Spinner } from 'react-bootstrap';
import DeleteDenyTime from './DeleteDenyTime';
import '../../../pages/company_operations/time_administration/Details.css';

interface IProps {
    entry: any;
    departmentId: string;
    allowedDepartments: any;
    refreshEmployee: any;
    employeeId: string | number;
    canEdit: any;
    inUsePC?: any;
    entryToDelete: any;
    setEntryToDelete: (entryToDelete: any) => void;
}

const TimeDisplay: React.FC<IProps> = (props: IProps) => {
    const { entry, departmentId, allowedDepartments, canEdit, inUsePC, entryToDelete, setEntryToDelete } = props;
    const [open, setOpen] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);
    

    const handleShowDeleteModal = () => {
        setEntryToDelete(entry);
        setShowDeleteModal(true);
        
        //console.log("ShowDeleteModal", showDeleteModal);
    }

    let isAllowed: boolean = false;
    isAllowed = canEdit;
    // ? allowedDepartments 
    //     ? allowedDepartments.findIndex((dept: DepartmentReferenceType) => dept.DepartmentId === Number(departmentId)) !== -1 
    //     : false 
    // : false;

    return (
        <>
            {showDeleteModal &&
                <DeleteDenyTime
                    showDeleteModal={showDeleteModal}
                    setShowDeleteModal={setShowDeleteModal}
                    deleting={deleting}
                    setDeleting={setDeleting}
                    entryToDelete={entryToDelete}
                    setEntryToDelete={setEntryToDelete}
                    inUsePC={inUsePC}
                    refreshEmployee={props.refreshEmployee}
                    show={true}
                />
            }
            <div className='time-admin-time-display-container'>
                <div>
                    <div className='time-admin-timesheet-label'>Category</div>
                    <div className='time-admin-timesheet-value'>{entry.Category}</div>
                </div>
                <div>
                    <div className='time-admin-timesheet-label'>Amount</div>
                    <div className='time-admin-timesheet-value'>{entry.Quantity.toFixed(2)}</div>
                </div>
                <div>
                    {(entry.LocatorComment || entry.SystemComment) && <div className='time-admin-timesheet-label'>Comment</div>}
                    {entry.LocatorComment && <div className="text-danger time-admin-time-display-comment-icon-wrapper">
                        <i className="material-icons">assignment_late</i>
                        <span className="font-weight-bold">Locator: </span>
                        <span className="ml-1">{entry.LocatorComment}</span>
                    </div>}
                    {entry.SystemComment && <div className="text-primary time-admin-time-display-comment-icon-wrapper">
                        <i className="material-icons">message</i>
                        <span className="font-weight-bold">System: </span>
                        <span>{entry.SystemComment}</span>
                    </div>}
                </div>                                     
                <div className='time-admin-time-display-action-wrapper'>
                    {entry.IsDisputed && <i title="Disputed. See Comments." className="material-icons text-danger" style={{marginRight: 10}}>assignment_late</i>}
                    {(!entry.IsApproved && isAllowed && !entry.IsReadOnly) && 
                        <button onClick={e => { setOpen(true) }} className="material-icons action-text" title="Edit Time">edit</button>
                    }
                    {isAllowed && !entry.IsReadOnly
                        ?
                        deleting
                            ?<Spinner size="sm" animation="border" title="Deleting Entry..." /> 
                            :<button onClick={handleShowDeleteModal} className="material-icons action-text text-danger" title="Delete Entry">delete</button>
                        :null
                    }
                    {entry.IsReadOnly && <i className="material-icons text-warning" title="Read Only Field.">lock</i>}
                    <AddTime 
                        employeeId={props.employeeId} 
                        refreshEmployee={props.refreshEmployee} 
                        departments={allowedDepartments} 
                        departmentId={departmentId} 
                        open={open} 
                        toEdit={entry} 
                        closeModal={() => setOpen(false)} 
                        inUsePC={inUsePC}
                    /> 
                </div>
            </div>
        </>
    );
}

export default TimeDisplay;